var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"router-link-newtab",attrs:{"href":_vm.googleMapAddress,"target":"_blank"}},[_vm._v(_vm._s(_vm.displayAddress))])}
var staticRenderFns = []

export { render, staticRenderFns }